import React from "react";

import { generateFullName } from "../../libs/Util";
import { IStudent } from "../../state";

import styles from "./StudentInfoLabel.module.scss";

export type Props = {
  student: IStudent;
};

export const StudentInfoLabel: React.FC<Props> = ({ student }) => {
  return (
    <div className={styles.studentInfo}>
      <p>
        <span>{generateFullName([student.last_name, student.first_name])}</span>
        {generateFullName([student.last_name_kana, student.first_name_kana])}
      </p>
      <span>ID / {student.identity}</span>
    </div>
  );
};
export default StudentInfoLabel;
